import {remCalc} from '../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import breakpointsObject from './foundations/breakpoints'

const {breakpoints} = breakpointsObject

export {breakpoints}
export {remCalc}
